<div class="one-level-at-once" *ngIf="!showEveryLevelAtOnce">
  <mat-radio-group class="interests-dialog__form__radio" (change)="onSelected($event)" *ngIf="!loadingNextLevel">
    <mat-radio-button
      *ngFor="let response of question.availableResponsesForCurrentLevel"
      [checked]="question.userResponsesForCurrentLevel.includes(response.uuid)"
      [value]="response.uuid">
      {{ response.text }}
    </mat-radio-button>
  </mat-radio-group>

  <div class="loading-animation" *ngIf="loadingNextLevel">
    <div class="animation-row">
      <div class="double-bounce">
        <div class="child double-bounce1"></div>
        <div class="child double-bounce2"></div>
      </div>
    </div>
  </div>

  <div class="levels-nav-buttons" *ngIf="!loadingNextLevel">
    <button
      mat-flat-button
      class="back-btn"
      *ngIf="showPreviousResponsesButton"
      [attr.aria-label]="'general.back' | translate"
      (click)="previousLevelButtonHandler()">
      <span class="odilo-icon" aria-hidden="true">navigate_before</span>
      <span aria-hidden="true">{{ 'general.back' | translate }}</span>
    </button>
    <button
      mat-flat-button
      class="back-btn"
      *ngIf="showNextResponsesButton"
      [attr.aria-label]="'general.next' | translate"
      (click)="nextLevelButtonHandler()">
      <span aria-hidden="true">{{ 'general.continue' | translate }}</span>
      <span class="odilo-icon" aria-hidden="true">navigate_next</span>
    </button>
  </div>
</div>

<div class="every-level-at-once" *ngIf="showEveryLevelAtOnce">
  <app-radio-question-level
    [question]="question"
    [responses]="availableResponsesFirstLevel"
    [level]="0"></app-radio-question-level>
</div>
